import { FC } from "react";
import { connectCurrentRefinements } from "react-instantsearch-dom";
import { CurrentRefinementsProvided } from "react-instantsearch-core";
import { Text } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";
import { find } from "lodash-es";
import { Price } from "src/atoms/Price";
import {
  AGES_FACET,
  CATEGORIES_FACET,
  COLOUR_FACET,
  PATTERN_FACET,
  PRICE_FACET,
  SIZE_FACET,
  STYLE_FACET,
  BRAND_FACET,
  DISCOUNT_FACET,
} from "src/utils/algolia";
import { filterFacets } from "src/organisms/AlgoliaProductList/utils/filterFacets";
import { FacetText } from "./FacetText";

interface Props extends CurrentRefinementsProvided {
  facet: string;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const CustomRefinements: FC<Props> = ({
  items,
  facet,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  const colourFacet = find(items, { attribute: COLOUR_FACET });
  const brandFacet = find(items, { attribute: BRAND_FACET });
  const sizeFacet = find(items, { attribute: SIZE_FACET });
  const styleFacet = find(items, { attribute: STYLE_FACET });
  const patternFacet = find(items, { attribute: PATTERN_FACET });
  const agesFacet = find(items, { attribute: AGES_FACET });
  const categoriesFacet = filterFacets(
    find(items, { attribute: CATEGORIES_FACET }),
    keepSelectedIgnoreInActive,
    selectedCatSlug
  );
  const priceFacet = find(items, { attribute: PRICE_FACET });
  const priceRefinement = priceFacet?.currentRefinement;
  const discountFacet = find(items, {
    attribute: DISCOUNT_FACET,
  });

  return (
    <Box ml={2}>
      {facet === SIZE_FACET &&
        sizeFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={sizeFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === COLOUR_FACET &&
        colourFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={colourFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === PATTERN_FACET &&
        patternFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={patternFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === STYLE_FACET &&
        styleFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={styleFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === AGES_FACET &&
        agesFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={agesFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === BRAND_FACET &&
        brandFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={brandFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === PRICE_FACET && priceRefinement && (
        <Flex>
          <Price
            price={Math.floor(
              (
                priceRefinement as unknown as {
                  min: number;
                }
              ).min || 0
            )}
          />
          <Text mx="2px"> - </Text>
          <Text as="span">
            {Math.ceil(
              (
                priceRefinement as unknown as {
                  max: number;
                }
              ).max || 0
            )}
          </Text>
        </Flex>
      )}
      {facet === CATEGORIES_FACET &&
        categoriesFacet?.items?.map((item, index) => {
          return (
            <FacetText
              key={`${item.label}-${index}`}
              itemsLength={categoriesFacet.items?.length}
              facet={item}
              index={index}
            />
          );
        })}
      {facet === DISCOUNT_FACET && discountFacet?.currentRefinement && (
        <FacetText facet={discountFacet} itemsLength={1} index={0} />
      )}
    </Box>
  );
};

const ActiveFilters = connectCurrentRefinements(CustomRefinements);

export default ActiveFilters;
